/**
 * @type {{shouldShowTgssConsent: null| boolean, shouldShowQRPage: null|boolean, isDocumentRetryBeenShown:boolean}}
 */
export const INITIAL_VALUE = {
    shouldShowTgssConsent: null,
    shouldShowQRPage: null,
    isDocumentRetryBeenShown: false,
};
